import { useState } from "react";

import { MetadataDashboardTemplate } from "@/components/Templates/MetadataDashboardTemplate";
import { useReviewMarkMutations } from "@/hooks/useReviewMarkMutations";
import ReviewItemDrawer from "./ReviewItemDrawer";
import { REVIEW_MARKS_DATASET, reviewRowText } from "./medicalReview";

/**
 * Every mark made on this trial, across records and reviewers — the
 * cross-record counterpart to the per-record history inside the drawer.
 */
export default function ReviewHistoryTable({ trialId }: { trialId: string }) {
  const [openItemId, setOpenItemId] = useState<number | null>(null);
  const { markItems, reopenItems, isMarking, contextHolder } =
    useReviewMarkMutations(trialId);

  return (
    <div className="flex flex-col gap-3">
      {contextHolder}

      <MetadataDashboardTemplate
        type={REVIEW_MARKS_DATASET}
        constants={{
          wikiLink: "/wiki/guides/medical-review",
          idLink: undefined,
        }}
        rowKey={(row) =>
          `${reviewRowText(row, "item_id")}-${reviewRowText(row, "performed_at")}`
        }
        selectionIdentifierColumn="subject_id"
        onRow={(row) => ({
          onClick: () => setOpenItemId(Number(row.item_id) || null),
          style: { cursor: "pointer" },
        })}
      />

      <ReviewItemDrawer
        trialId={trialId}
        itemId={openItemId}
        open={openItemId !== null}
        onClose={() => setOpenItemId(null)}
        onMark={(target) => markItems([target])}
        onReopen={(target) => reopenItems([target])}
        onOpenItem={(item) => setOpenItemId(item.id)}
        marking={isMarking}
      />
    </div>
  );
}
